import SettingsAlarmsContainer from './alarms/SettingsAlarmsContainer';
import SettingsUsersContainer from './users/SettingsUsersContainer';
import SettingsAccountContainer from './user/SettingsAccountContainer';

export const tabs = [
  {
    key: 'default',
    pathname: '/settings',
    title: 'alarms.title',
    iconName: 'alarm',
    render: SettingsAlarmsContainer,
    access: 'all',
  },
  {
    key: 'alarms',
    pathname: '/settings/alarms',
    title: 'alarms.title',
    iconName: 'alarm',
    render: SettingsAlarmsContainer,
    access: ['configurator', 'admin'],
  },
  {
    key: 'users',
    pathname: '/settings/users',
    title: 'usersConfig.title',
    iconName: 'users',
    render: SettingsUsersContainer,
    access: ['admin'],
  },
  {
    key: 'account',
    pathname: '/settings/account',
    title: 'accountConfig.title',
    iconName: 'user circle',
    render: SettingsAccountContainer,
    access: 'all',
  },
];



// WEBPACK FOOTER //
// ./src/components/Settings/utils.js